import React from "react";

import { Wrapper } from "./Spacer.styles";
const Spacer = () => (

    <Wrapper>
        <div>
        
        </div>
    </Wrapper>


);

export default Spacer;